<div class="receipt-viewer-wrapper">
  <rms-file-preview [path]="Path"></rms-file-preview>
</div>
